// Pure market-clock helpers (no React, no aliases) so they can be unit-tested.
// Market hours in New York time; the calendar row comes from GET /v1/market/calendar when available.

const partsET = (now) => {
  const p = new Intl.DateTimeFormat("en-CA", {
    timeZone: "America/New_York", year: "numeric", month: "2-digit", day: "2-digit",
    hour: "2-digit", minute: "2-digit", hourCycle: "h23", weekday: "short",
  }).formatToParts(now);
  const g = (t) => p.find((x) => x.type === t)?.value;
  return { date: `${g("year")}-${g("month")}-${g("day")}`, minutes: Number(g("hour")) * 60 + Number(g("minute")), weekday: g("weekday") };
};

/** Today's date in New York, YYYY-MM-DD. */
export const todayET = (now = new Date()) => partsET(now).date;

const toMin = (hhmm, fallback) => {
  const m = /^(\d{1,2}):(\d{2})$/.exec(hhmm || "");
  return m ? Number(m[1]) * 60 + Number(m[2]) : fallback;
};

export const WINDOW_START = 8 * 60 + 30; // 08:30 ET, ten minutes before Run 1

/**
 * The state of the trading day at `now` for the calendar row (or null → fallback rules).
 * `session`: the checkpoint window (08:30 → Run 6 + 20 min, fallback 16:30) — poll while true.
 * `open`: 08:30 → the close (fallback 16:00) — the only time a session may be labelled LIVE.
 */
export function marketWindow(calendar, now = new Date()) {
  const { date, minutes, weekday } = partsET(now);
  const known = calendar && calendar.date === date;
  const tradingDay = known ? !!calendar.is_trading_day : !["Sat", "Sun"].includes(weekday);
  const close = known ? toMin(calendar.close_et, 16 * 60) : 16 * 60;
  const run6 = known ? toMin(calendar.run6_et, close + 10) : 16 * 60 + 10;
  const sessionEnd = known ? run6 + 20 : 16 * 60 + 30;
  return {
    today: date,
    tradingDay,
    holiday: known ? calendar.holiday || null : null,
    earlyClose: known ? !!calendar.early_close : false,
    closeET: known ? calendar.close_et || "16:00" : "16:00",
    session: tradingDay && minutes >= WINDOW_START && minutes <= sessionEnd,
    open: tradingDay && minutes >= WINDOW_START && minutes < close,
    fromCalendar: !!known,
  };
}

